import { ProFormUploadDragger } from '@ant-design/pro-components'
import type { UploadFile } from 'antd'
import type React from 'react'
import { EditableLabel } from '../components/EditableLabel'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'
import { useMergedFieldProps } from '../utils/mergeFieldProps'

export type UploadDraggerFieldProps = React.ComponentProps<typeof ProFormUploadDragger>

export function UploadDraggerField(props: UploadDraggerFieldProps) {
  const fieldCtx = useFieldContext<UploadFile[] | undefined>()
  const { formItemProps, fieldProps, proFieldProps, className, ...rest } = props

  const editable = useEditableFieldMode<UploadFile[] | undefined>()

  const merged = useMergedFieldProps({
    fieldCtx,
    editable,
    props,
    fieldDefaults: {
      fieldProps: {
        value: undefined as unknown as never,
        fileList: Array.isArray(fieldCtx.state.value) ? fieldCtx.state.value : [],
        onChange: (info: { fileList: UploadFile[] }) => {
          fieldCtx.handleChange(info.fileList)
        },
      },
    },
  })

  const _currentList: UploadFile[] = Array.isArray(fieldCtx.state.value) ? fieldCtx.state.value : []

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProFormUploadDragger
        {...rest}
        label={
          <EditableLabel
            mode={editable.mode}
            enterEdit={editable.enterEdit}
            exitRead={editable.exitRead}
            onUndo={editable.undoAndExit}
            canUndo={editable.canUndo}
          >
            {rest.label}
          </EditableLabel>
        }
        proFieldProps={merged.proFieldProps}
        formItemProps={merged.formItemProps}
        fieldProps={merged.fieldProps}
      />
    </EditableShell>
  )
}
